import React, { useEffect, useState } from 'react'

function TextField({ index, e, handleUpdate, val }) {

    const [data, setData] = useState('')

    useEffect(() => {

        // setData(e[index] === null || e[index] === '' ? "NA" : e[index])
        setData(val)

    }, [val])

    const handleChange = (e) => {
        setData(e.target.value)
        handleUpdate(e.target.name, e.target.value)
    }

    return (
        <input type='text' name={e} id={e} value={data} onChange={handleChange} />
    )
}

export default TextField